<template>
  <div class="km-prod-box">
    <div class="prod-tabs">
      <button v-for="tab in tabs" :key="tab.value" :class="['prod-tab-btn', { active: activeTab === tab.value }]" @click="activeTab = tab.value">
        <Icon :type="tab.icon" size="16" />
        {{ tab.label }}
      </button>
    </div>

    <div class="prod-tab-content">
      <c-production v-if="activeTab === 'production'" :cards="prodData.filter((x) => x.iid <= 8)"></c-production>
      <c-production v-if="activeTab === 'test'" :cards="prodData.filter((x) => x.iid >= 9 && x.iid <= 10)"></c-production>
      <c-production v-if="activeTab === 'other'" :cards="prodData.filter((x) => x.iid >= 11 && x.iid <= 13)"></c-production>
    </div>
  </div>
</template>

<script>
import cProduction from './prod-list.vue';
import { mapState } from 'vuex';

export default {
  name: 'prod-box',
  data() {
    return {
      activeTab: 'production',
      tabs: [
        { label: '电容器生产类设备', value: 'production', icon: 'ios-construct' },
        { label: '电容器实验类设备', value: 'test', icon: 'ios-flask' },
        { label: '其他设备', value: 'other', icon: 'ios-settings' },
      ],
    };
  },
  computed: {
    ...mapState({
      prodData: (state) => state.prod.prodData,
    }),
  },
  components: {
    cProduction,
  },
};
</script>

<style scoped lang="less">
.km-prod-box {
  width: 100%;
}

/* 标签页按钮组 */
.prod-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 0;
}

.prod-tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: -2px;
  border-radius: 4px 4px 0 0;

  &:hover {
    color: var(--primary);
    background: var(--primary-bg);
  }

  &.active {
    color: var(--primary);
    font-weight: 600;
    border-bottom-color: var(--accent);
    background: transparent;
  }
}

.prod-tab-content {
  min-height: 200px;
}

/* 响应式 */
@media (max-width: 768px) {
  .prod-tabs {
    gap: 4px;
  }

  .prod-tab-btn {
    padding: 9px 14px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .prod-tab-btn {
    padding: 8px 12px;
    font-size: 12px;
    flex: 1;
    justify-content: center;
    text-align: center;
  }
}
</style>
